import { render, staticRenderFns } from "./LoginComp.vue?vue&type=template&id=6c71d616&scoped=true&"
import script from "./LoginComp.vue?vue&type=script&lang=js&"
export * from "./LoginComp.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/login.scss?vue&type=style&index=0&id=6c71d616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71d616",
  null
  
)

export default component.exports